import React, { useState } from 'react'
import { withUserStore } from '../../../contexts/UserStore'
import { Button, Input } from '@byscott-io/corebyscott'
import Lex from '../../Shared/Lex'
// import {withJournalEntriesApi} from "../../../apis/journal_entries_api"
import CommentThread from '../CommentThread/CommentThread'
import TimeAgo from 'react-timeago'

const JournalEntry = ({ isReply, journalEntry: je, userStore }) => {
  const [journalEntry, setJournalEntry] = useState(je)
  const [editing, setEditing] = useState(false)
  const label = isReply ? 'Reply' : 'Journal Entry'

  let accountsUser = null
  const getAccountsUser = () => accountsUser ||= userStore.getAccountsUserById(journalEntry.accountsUserId)

  const form = {}

  const formatWrittenAt = (date) => {
    return <TimeAgo date={date} />
  }

  const save = () => {
    const data = { ...journalEntry, content: form.content.value }
    userStore.updateJournalEntry(data, () => {
      setJournalEntry(data)
      setEditing(false)
    })
  }

  const buttons = (
    <span className="inline-block float-right">
      <i className="icon-button margin-right fas fa-tags" />
      {(!editing) &&
        <i
          className="icon-button margin-right fas fa-pencil"
          onClick={() => setEditing(true)}
        /> ||
          <i
            className="icon-button margin-right fas fa-xmark"
            onClick={() => setEditing(false)}
          />}
    </span>
  )

  // <Container fluid={true} className="border1 rounded5px margin-bottom-5px">
  const journalEntryDiv = () => {
    return (
      <div className="">
        <div className="size-75">
          {getAccountsUser()?.nickname || getAccountsUser()?.firstName} journaled {formatWrittenAt(journalEntry?.createdAt)}:
        </div>
        <CommentThread depth={1} buttons={buttons} content={journalEntry.content} editing={editing} commentable={journalEntry} isReply={false}>
          {editing &&
            <>
              <div className="margin-bottom-5px size-90">
                <Input
                  type="textarea" innerRef={el => form.content = el} defaultValue={journalEntry?.content}
                  placeholder={label}
                />
              </div>
              <div className="text-right margin-bottom-5px size-90">
                <Button size="sm" color="success" onClick={save}><Lex term="save" /></Button>
              </div>
            </>}
        </CommentThread>
      </div>)
  }

  return (
    <div className="cbs-scope border1 rounded5px padding-5 margin5 margin-left-5px">
      {journalEntryDiv()}
    </div>)
}

export default withUserStore(JournalEntry)
